import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { apiRequest } from '../../utils';

/* A slim bar on top of every screen when WE are signed in as somebody — with the support
   password, to see what they see. A person often holds several cards (a venue's manager is a
   supplier AND a customer contact), and the login picks one; this keeps the others one tap
   away. Nobody else ever sees it: the API says so per session (/api/me → support), cached in
   sessionStorage like the NavBar's role, which a logout clears. */
const SupportBar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [support, setSupport] = useState(() => sessionStorage.getItem('supportSession') === '1');

  useEffect(() => {
    if (sessionStorage.getItem('supportSession') !== null) return;
    let cancelled = false;
    apiRequest('GET', '/me')
      .then((me) => {
        if (cancelled || !me) return;
        sessionStorage.setItem('supportSession', me.support ? '1' : '0');
        setSupport(!!me.support);
      })
      .catch(() => { /* not signed in, or no answer: no bar */ });
    return () => { cancelled = true; };
  }, []);

  if (!support) return null;
  return (
    <div className="d-flex align-items-center justify-content-between gap-2 px-3 py-1 small"
         style={{ background: '#fff3cd', color: '#664d03', position: 'sticky', top: 0, zIndex: 1030 }}>
      <span>{t('supportSession')}</span>
      <button type="button" className="btn btn-sm btn-outline-dark py-0" onClick={() => navigate('/role')}>
        {t('switchRole')}
      </button>
    </div>
  );
};

export default SupportBar;
